import React from 'react';
import {config} from '../Constants';
import SelectParkingZone from './selectParkingZoneView';
import ConfirmedView from './confirmedView';
import AlreadyTakenView from './alreadyTaken';
import axios from 'axios';
import Papa from 'papaparse'
// import moment from "moment"
const moment = require('moment-timezone');

export default class VisitorPass extends React.Component{
    
    constructor(){
        super();
        this.state = {                   
            API_URL : config.url.API_URL,
            submitted : false,
            showConfirmation : false,
            showForm : false,
            isAlreadyTaken : false,
            isFreeHourExpired : false,
            isIOS : false,
            freeHours : '',
            startDate : Date,
            endtDate : Date,
            ZoneCode : String,
            zoneQuery : false,
            zoneList : [],
            currentZone : [],
            parkingOptionList : [],
            installationList : [],
            visitorPassResponse : '',
            currentParkingOption : [],
            ParkingOption : [],
            visitorPassConfirmation :{},
            ZoneId : '',
            PlateNumber : '',
            formData : {},
            sheetData: {},
            userLanguage : '',
            purchasedConsecutive: false
        }
    }
    

    componentDidMount(){   
        var userLang = navigator.language || navigator.userLanguage; 
        console.log(userLang)
        this.setState({userLanguage : userLang})
        
        this.getAllZones();   
        this.getAllInstallations();   
        // this.getLocalData(); 
        this.getGoogleSheetData();
    }

    getGoogleSheetData(){
      Papa.parse("https://docs.google.com/spreadsheets/d/19v2WbZtUApzDHlE-fkjPPe5RJ9tVUzSfF0EmhAh8-pQ/pub?gid=1655665746&output=csv", {
        download: true,
        header: true,
        complete: (res) => {
          console.log(res.data);
          let result = this.mapLanguages(this.state.userLanguage, res.data);
          this.setState({sheetData : result}, ()=>{console.log(this.state.sheetData)})
        },
      });
      // axios.get("https://sheet.best/api/sheets/135a1d49-6321-484e-b93e-e00287b52292/tabs/English").then((res)=>{
      //   console.log(res);
      //   let result = this.mapLanguages(this.state.userLanguage, res.data);
      //   this.setState({sheetData : result}, ()=>{console.log(this.state.sheetData)})
      // })
      // Tabletop.init({
      //   key: 'https://docs.google.com/spreadsheets/d/19v2WbZtUApzDHlE-fkjPPe5RJ9tVUzSfF0EmhAh8-pQ/edit?usp=sharing',
      //   callback: googleData => {                     
      //       let result = this.mapLanguages(this.state.userLanguage, googleData.English.elements);
      //       console.log(googleData.English.elements)
      //       this.setState({sheetData : result}, ()=>{console.log(this.state.sheetData)})
      //   },
      //   simpleSheet: false
      // })
    }

    mapLanguages(language, languageData){
      let languageArray = [];
      console.log(language.split('-')[0])
      languageData.forEach((item)=>{        
        if(item[language] !== undefined || item[language.split('-')[0]] !== undefined){
          languageArray[item.key] = item[language] || item[language.split('-')[0]];
        }else{
          languageArray[item.key] = item['en'];
        }
      })

      console.log(languageArray)
      return languageArray;
    }

    getLocalData(){
      let savedPlateNo = localStorage.getItem('vpp-PlateNo');
      savedPlateNo = JSON.parse(savedPlateNo);
      let form = {
        PlateNo : savedPlateNo
      }
      this.setState({
        formData : form
      })
    }

    getAllZones(){    
        axios.get(this.state.API_URL+'/GetAllParkingZones')
        .then(response => {
            this.setState({
                zoneList : response.data.zones,
                ZoneId : response.data.zones[0].id
            })
            let ZoneCode = this.props.match.params.id;
            let filteredZoneCode = this.state.zoneList.filter(x=>x.zoneCode === ZoneCode);
            if(ZoneCode && filteredZoneCode.length === 0){
            this.props.history.push('/')
            }
            else if(ZoneCode && filteredZoneCode.length > 0){
                this.setState({zoneQuery : true, currentZone : filteredZoneCode})
                this.setState({
                    ZoneId : this.state.currentZone[0].id,
                    freeHours : this.state.currentZone[0].freeHours
                })                
            }        
            this.getAllOptions();
        });
      }

    getAllOptions(){
        axios.get(this.state.API_URL+'/GetAllParkingOptions')
        .then(response => {
            this.setState({parkingOptionList : response.data.options})
            var newCurrentParkingOption = this.state.currentParkingOption.slice();
                newCurrentParkingOption.push(this.state.parkingOptionList[0]);
            this.setState({
                currentParkingOption : newCurrentParkingOption,
                ParkingOption : newCurrentParkingOption[0].id
            })
            let ZoneCode = this.props.match.params.id;
            let filteredZoneCode = this.state.zoneList.filter(x=>x.zoneCode === ZoneCode);
            if(ZoneCode && filteredZoneCode.length === 0){
            this.props.history.push('/')
            }else if(ZoneCode && filteredZoneCode.length > 0){
                let test = this.state.zoneList.filter(x=>x.zoneCode === ZoneCode);
                let options = this.state.parkingOptionList.filter(x=>x.zoneId === test[0].id);
                this.setState({
                    currentParkingOption : options,
                    ParkingOption : options[0].id
                })  
            }
            this.setState({
            showForm : true
            })         
        });
    }

    getAllInstallations(){
        axios.get(this.state.API_URL+'/GetAllInstallations')
        .then(response => {
          this.setState({
            installationList : response.data.installations
          })          
        });
      }
    
    onZoneChange(value){        
        let filterOptions = this.state.parkingOptionList.filter(x=>x.zoneId == value);
        this.setState({ParkingOption : -1});                   
        this.setState({
            currentParkingOption : filterOptions,
            ZoneId : filterOptions[0].zoneId
        }, () => {
            console.log(this.state.currentParkingOption,this.state.ZoneId);
          });  
    }

    handleChange(event){
        console.log(event.target.value);
        let form = this.state.formData;
        form[event.target.name] = event.target.value;       
        this.setState({
            formData : form
        },()=>{console.log(this.state.formData)});            
      }

    checkLocalParkings(){
      let parkings = JSON.parse(localStorage.getItem('parkings')) || [];
      console.log(parkings);
      const a1 = [
        {date: '07052023', plate: 'TEST123'},
        {date: '06052023', plate: 'TEST123'},
        {date: '04052023', plate: 'TEST123'}
      ];
      let parkingPurchase = [];
      for(let i = 1; i < 4; i++){
        let date = moment(new Date()).subtract(i, 'd').format("DDMMYYYY")
        let findDate = parkings.find(x=> x.date == date && x.plate == this.state.formData['PlateNo'])
        console.log(findDate)
        if(findDate){
          parkingPurchase.push(true)
        }
      }
      if(parkingPurchase.length >= 3){
        this.setState({purchasedConsecutive : true})
        return true;
      }
    }

    onSubmit() {
      if(this.checkLocalParkings()){
        console.log('in')
        return;
      }
      let parkings = JSON.parse(localStorage.getItem('parkings')) || [];
      parkings.push({
        plate: this.state.formData['PlateNo'],
        date: moment(new Date()).format("DDMMYYYY")
      })
      localStorage.setItem('parkings', JSON.stringify(parkings));
      console.log(this.state.installationList, this.state.zoneList)
        this.submitted = true;
        if(this.state.zoneQuery == true){
        this.setState({ParkingOption : this.state.currentParkingOption[0].id})
        }else if(!this.state.zoneQuery){
        this.setState({ParkingOption : this.state.currentParkingOption[0].id})
        }
        if (this.state.ParkingOption === -1 || this.state.ZoneId == undefined || this.state.ZoneId == null) {
        return;
        }
        let selectedOption = this.state.currentParkingOption.filter(x=>x.id == this.state.ParkingOption);
        let selectedZone = this.state.zoneList.filter(x => x.id == this.state.ZoneId);
        let installation = this.state.installationList.filter(x => x.id == selectedZone[0].installationId)
        console.log(selectedOption,selectedZone,installation)
        const iParkIn = {
        ins_id: installation[0].installationCode,
        lic_pla: this.state.formData['PlateNo'],
        date: moment(new Date()).format("HHmmssDDMMYYYY"),
        grp_id: selectedZone[0].zoneCode,
        tar_id: selectedOption[0].optionCode,
        amou_off: "5",
        prov: "VISITOR_PASS",
        vers: "1.0",
        ah:""
        }

        const amountSteps = {
        ipark_in: iParkIn
        }

        const headerOptions = { 'Content-Type': 'application/json' };
        const amountStepsReq = JSON.stringify(amountSteps);

        console.log(iParkIn,amountStepsReq,headerOptions)
        axios.post(this.state.API_URL+'/SubmitVisitorPass', amountStepsReq, {headers: headerOptions})
        .then(result => {   
          console.log('breakpoint 2', result.data);
          this.setState({visitorPassResponse : result.data})
          console.log('breakpoint 3', this.state.visitorPassResponse);
          console.log('breakpoint 4',this.state.visitorPassResponse.ipark_out.t_min);
          var freeMinutes = this.state.visitorPassResponse.ipark_out.t_min;
          var convertIntoHours  = freeMinutes/60;
          this.setState({freeHours : convertIntoHours})
          console.log('breakpoint 5', this.state.freeHours);
          if(this.state.visitorPassResponse.ipark_out.r == "1"){
            console.log('breakpoint 6');
            this.setState({showConfirmation : true})
            if(this.state.visitorPassResponse.ipark_out.t_min != "0"){
              console.log('breakpoint 7');
              var d_init = moment(this.state.visitorPassResponse.ipark_out.d_init, "MM/DD/YYYY hh:mm:ss a").tz('America/New_York').format('"MM/DD/YYYY hh:mm:ss a"');
              var d_min = moment(this.state.visitorPassResponse.ipark_out.d_min, "MM/DD/YYYY hh:mm:ss a").tz('America/New_York').format('"MM/DD/YYYY hh:mm:ss a"');
              this.setState({startDate : d_init,endtDate : d_min})
              let hours = parseInt(this.state.visitorPassResponse.ipark_out.t_min)/60;          
                let passConfirmation = {
                    CNo : "CN000001",
                    Hours : hours,
                    RemainingVisitors : 2,
                    ParkingZone : selectedZone[0].name,
                    ZoneCode : selectedZone[0].zoneCode
                }
              this.setState({
                visitorPassConfirmation : passConfirmation,
              })          
              console.log(this.state.visitorPassConfirmation)
            }else{
              console.log('breakpoint 8');
              let device = this.getMobileOperatingSystem();
              if(device == "iOS"){
                console.log('breakpoint 9');
                this.isIOS = true;
              }else{
                console.log('breakpoint 10');
                this.isIOS = false;
              }
              console.log('breakpoint 11');
              this.setState({isAlreadyTaken : true})
              this.setState({startDate : moment(this.state.visitorPassResponse.ipark_out.d_min, "MM/DD/YYYY hh:mm:ss a").tz('America/New_York').format('"MM/DD/YYYY hh:mm:ss a"')})
              this.setState({endtDate : moment(this.state.visitorPassResponse.ipark_out.d_max, "MM/DD/YYYY hh:mm:ss a").tz('America/New_York').format('"MM/DD/YYYY hh:mm:ss a"')})
              console.log(this.state.startDate)
              let passConfirmation = {
                  ParkingZone : selectedZone[0].name,
                  ZoneCode : selectedZone[0].zoneCode
              }
              this.setState({
                  visitorPassConfirmation : passConfirmation
              })

              let currentDate   = new Date();
              let sd = new Date(this.state.startDate);
              let seconds = (sd.getTime() - currentDate.getTime()) / 1000;
              if(seconds > 0){
                console.log('breakpoint 12');
                this.isFreeHourExpired = false;
              }else{
                console.log('breakpoint 13');
                this.isFreeHourExpired = true;
              }
            }

          }
          else{
            console.log('breakpoint 14');
            let passConfirmation = {
                success : false
            }
            this.setState({visitorPassResponse : passConfirmation})
          }
        });
        localStorage.setItem('vpp-PlateNo',JSON.stringify(this.state.formData['PlateNo']))        
    }

    resetForm() {
      window.location.reload();
    }

    clearPlateNo(e){
      console.log(this.state.formData)
      let form = {
        parkingOption : this.state.formData['parkingOption'],
        PlateNo : ""
      }
      this.setState({
        formData : form
      })
      console.log(this.state.formData)
    }

    getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor;// || window.opera;
      
            // Windows Phone must come first because its UA also contains "Android"
          if (/windows phone/i.test(userAgent)) {
              return "Windows";
          }
      
          if (/android/i.test(userAgent)) {
              return "Android";
          }
      
          // iOS detection from: http://stackoverflow.com/a/9039885/177710
          if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            this.setState({isIOS : true})
              return "iOS";
          }
      
          return "unknown";
      }

    render(){        
        return( 
            <div>
                {(this.state.showForm && !this.state.showConfirmation) && <SelectParkingZone zoneList = {this.state.zoneList} option = {this.state.currentParkingOption}
                zoneQuery = {this.state.zoneQuery} showForm = {this.state.showForm} freeHours = {this.state.freeHours}
                currentZone = {this.state.currentZone} onZoneChange={(e)=>{this.onZoneChange(e)}}
                handleChange={(e)=>{this.handleChange(e)}} formData = {this.state.formData} onSubmit = {()=>{this.onSubmit()}}
                resetForm = {()=>{this.resetForm()}} clearPlateNo = {()=>{this.clearPlateNo()}}
                sheetData = {this.state.sheetData} purchasedConsecutive={this.state.purchasedConsecutive}/>}

                {this.state.showConfirmation && !this.state.isAlreadyTaken && 
                  <ConfirmedView 
                    freeHours = {this.state.freeHours} 
                    visitorPassModel = {this.state.formData}
                    visitorPassConfirmation = {this.state.visitorPassConfirmation} 
                    startDate = {this.state.startDate}
                    endtDate = {this.state.endtDate} 
                    sheetData = {this.state.sheetData}
                    resetForm = {()=>{this.resetForm()}}
                    />}

                {(this.state.showConfirmation && this.state.isAlreadyTaken) && 
                  <AlreadyTakenView 
                    visitorPassModel = {this.state.formData}
                    isFreeHourExpired = {this.state.isFreeHourExpired} 
                    visitorPassConfirmation = {this.state.visitorPassConfirmation} 
                    startDate = {this.state.startDate} isIOS = {this.state.isIOS} 
                    sheetData = {this.state.sheetData}
                    resetForm = {()=>{this.resetForm()}}
                    />}
            </div>
        )
    }
}
